import { jsxs as c, jsx as o } from "react/jsx-runtime";
import { clsx as i } from "../../utils/clsx.js";
import '../../assets/Separator.css';const l = "_root_1omks_1", _ = "_separator_1omks_4", m = "_content_1omks_9", v = "_thin_1omks_12", p = "_vertical_1omks_18", d = "_text_1omks_32", t = {
  root: l,
  separator: _,
  content: m,
  thin: v,
  vertical: p,
  text: d
};
function N(r) {
  const {
    content: s,
    thin: a = !1,
    vertical: n = !1
  } = r, e = i(t.root, {
    [t.text]: !!s,
    [t.thin]: a,
    [t.vertical]: n
  });
  return s ? /* @__PURE__ */ c("div", { className: e, children: [
    /* @__PURE__ */ o("div", { className: t.separator }),
    /* @__PURE__ */ o("div", { className: t.content, children: s }),
    /* @__PURE__ */ o("div", { className: t.separator })
  ] }) : /* @__PURE__ */ o("div", { className: e, children: /* @__PURE__ */ o("div", { className: t.separator }) });
}
export {
  N as Separator
};
